import { VDialog } from 'vuetify/lib/components/VDialog';

var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c(VDialog,{attrs:{"persistent":"","light":"","width":"540"},model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[_c('member-edit',{attrs:{"dialog":_vm.dialog,"is-edit":_vm.isEdit},on:{"on-click":_vm.close}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }